import { type MiddlewareFunction, type Params } from 'react-router';

import { isMemberLoggedIn } from '@trello/authentication';

/**
 * Logged In Guard Middleware Factory
 *
 * This middleware redirects to the login page if the user is not logged in.
 * If a redirect URL is provided, it will redirect to the given URL instead of the login page.
 *
 * @param createRedirectUrl The function that creates the redirect URL from route params.
 * @returns The React Router middleware function.
 */
export const createLoggedInGuard =
  (
    createRedirectUrl?: (params: Readonly<Params<string>>) => string,
  ): MiddlewareFunction =>
  async ({ params }): Promise<Response | void> => {
    if (!isMemberLoggedIn()) {
      const loginUrl = `/login?returnUrl=${encodeURIComponent(
        window.location.pathname + window.location.search,
      )}`;

      const url = createRedirectUrl ? createRedirectUrl(params) : undefined;

      window.location.assign(url ?? loginUrl);

      // Return a 401 response to stop further processing of the route
      return new Response(null, {
        status: 401,
      });
    }
  };
